export default "__VITE_ASSET__o0N8JRUn__"